import React from "react";
import {
    Link,
    Stack,
} from "@mui/material";
import {
    
    ViewModule,
    Edit,
} from "@mui/icons-material";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";
import { useHref } from "react-router";
import {StyledNavLink} from "../../../../share/components/styled/Table";

const UserListItemTools = ({data, onClickUrl, onEditUrl, onDelete}) => {

    const session = useStateSession()

    const onClickHref = useHref(onClickUrl);
    const onEditHref = useHref(onEditUrl);

    const showEdit = 
        session.hasPermission('', 'applications/auth/entities/Users/update/view')
    
    
    
    return (
        <Stack direction="row" spacing={1} sx={{ justifyContent: "center" }}>
            <Link size="small" component={StyledNavLink} arial-label={t`View`}
                  to={ onClickHref }
                  viewTransition={true}
            >
                <ViewModule />
            </Link>
            { showEdit &&
                <Link size="small" component={StyledNavLink} arial-label={t`Edit`}
                      to={ onEditHref }
                      viewTransition={true}
                >
                    <Edit />
                </Link>
            }
            
        </Stack>
    )
}

export default UserListItemTools;
